import { UserType } from '@/types/member';

// 用户类型列表
export const USER_TYPE_LIST = [
  { id: 1, label: '成人', value: UserType.ADULT },
  { id: 2, label: '少儿', value: UserType.CHILD },
];
